import { useState, useEffect } from "react";
import "./OurApproach.css";

export default function OurApproach() {
  const steps = [
    {
      id: 1,
      title: "Discovery Phase",
      content: "We deep-dive into your business DNA to uncover hidden opportunities and map out a bulletproof strategy.",
      metric: "100% Alignment",
      subText: "Stakeholder Interviews",
      icon: "fa-magnifying-glass-chart"
    },
    {
      id: 2,
      title: "Design & Dev",
      content: "Crafting high-fidelity prototypes and writing scalable code that turns your vision into a digital powerhouse.",
      metric: "Pixel Perfect",
      subText: "Agile Sprints",
      icon: "fa-code-branch"
    },
    {
      id: 3,
      title: "Deployment",
      content: "Launching your product with zero downtime, ensuring a smooth transition to your production environment.",
      metric: "CI/CD Automated",
      subText: "Cloud Infrastructure",
      icon: "fa-cloud-arrow-up"
    },
    {
      id: 4,
      title: "Testing & QA",
      content: "Rigorous stress tests and security audits to ensure your product is invincible against bugs and threats.",
      metric: "99.9% Bug-Free",
      subText: "Automated Testing",
      icon: "fa-shield-check"
    },
    {
      id: 5,
      title: "Maintenance",
      content: "Continuous monitoring and proactive updates to keep your technology ahead of the competition.",
      metric: "24/7 Monitoring",
      subText: "Performance Tuning",
      icon: "fa-rocket"
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % steps.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused, steps.length]);

  const activeStep = steps[activeIndex];

  return (
    <div className="approach-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <p className="process-subtitle">ELITE WORKFLOW</p>
          <h2 className="section-title">
            Our <span className="highlight-text">Engineered Process</span>
          </h2>
        </div>

        <div className="row align-items-center">
          {/* LEFT: Interactive Timeline */}
          <div className="col-lg-6">
            <div className="timeline-container" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
              {steps.map((step, index) => (
                <div
                  key={step.id}
                  className={`timeline-item ${activeIndex === index ? "active" : ""}`}
                  onClick={() => setActiveIndex(index)}
                >
                  <div className="timeline-number">0{step.id}</div>
                  <div className="timeline-content">
                    <h3>{step.title}</h3>
                    <p>{step.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT: Dynamic Data Visualizer */}
          <div className="col-lg-6 mt-5 mt-lg-0 d-flex justify-content-center">
            <div className="data-visualizer-card">
               <div className="card-glare"></div>
               <div className="card-content" key={activeIndex}>
                  <i className={`fa-solid ${activeStep.icon} main-icon`}></i>
                  <h4 className="metric-value">{activeStep.metric}</h4>
                  <p className="subtext">{activeStep.subText}</p>
                  
                  <div className="loading-bar-container">
                    <div className="loading-bar-fill"></div>
                  </div>
                  
                  <div className="status-badge">
                    <span className="dot"></span> ACTIVE PHASE
                  </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}